// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://api.ticketernal.com',
  //apiUrl: 'http://localhost:3000',
  googleApiKey: '&key=AIzaSyClwjNvrkSxPyAGQJldorK3f4AdaIQt9UM',
  userAnonymous: '4e340395-a4e5-4419-97ea-d9a417895273',
  userAnonymousLocal: '78d48d53-742d-4844-9608-b8521c7e8910'
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
